import {
    Component,
    OnInit,
    ViewContainerRef,
    Renderer2
} from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import {
    Router
} from '@angular/router';
import {
    Modal
} from 'angular2-modal/plugins/bootstrap';
import {
    ToastrService
} from 'ngx-toastr';
import {
    Subscription
} from 'rxjs';

import {
    EchexpaymentService
} from '../echexpayment.service';
import {
    GlobalEventMangerService
} from '../global-event-manger.service';
import {
    LocalstorageService
} from '../localstorage.service';
import {
    UserService
} from '../user.service';
import { 
	Constants 
} from '../app.constants';

class DataTablesResponse {
	data: any[];
	draw: number;
	recordsFiltered: number;
	recordsTotal: number;
}

@Component({
    selector: 'echexpayment-echexmerchant',
    templateUrl: './echexmerchant.component.html',
    styleUrls: ['./echexmerchant.component.css'],
    providers: [Modal]
})
export class EchexmerchantComponent implements OnInit {
    public token: string;
    show: boolean = true;
    busy: Subscription;

    public data;
    public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "created_at";
    public sortOrder = "desc";

    public roleList: string;
    public currentUser: any = {};
	public user_token: string;
    public id: string;
	private actionUrl: string;

    constructor(private router: Router, vcRef: ViewContainerRef, private renderer: Renderer2, public modal: Modal, private toastr: ToastrService, private userService: UserService, private echexpaymentService: EchexpaymentService, private globalEventMangerService: GlobalEventMangerService, private localStorageService: LocalstorageService, private http: HttpClient, private _constants: Constants) {
        this.router = router;
        this.currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  this.currentUser.data.user_token;
		this.actionUrl = _constants.ServerWithApiUrl;
	    let userDetails = this.localStorageService.getData("currentUser");
		this.id = userDetails && userDetails._id;
    }

    ngOnInit() {
        // this.getMerchant();
		this.getAllTransactionAdvance();
    }

	// get transcation data for advanced tab
    getAllTransactionAdvance(model: any = {}, search_but: any = '') {
        model._id = this.id;
        model.token = this.id;
        model.user_token = this.token;
    
		var datatable = $('#advance-datatable').DataTable();
		datatable.destroy();

		$('#advance-datatable').DataTable({
			pagingType: 'full_numbers',
			pageLength: 25,
			serverSide: true,
			processing: false,
			destroy: true,
			order: [[4, 'desc']],
			language: {
				searchPlaceholder: "Email..."
			},
			ajax: (dataTablesParameters: any, callback) => {
				var data = {
					user_token: this.token,
					token: this.id,
					_id: this.id
				}

				let params = new URLSearchParams();
				const headers = new HttpHeaders().set('Authorization', `Bearer ${data.user_token}`);  
				let resp_data = < any > {};
				dataTablesParameters = {...dataTablesParameters, ...model};
				this.busy = this.http.post<DataTablesResponse>(
					this.actionUrl +'merchant/lists',
					dataTablesParameters,
					{headers}
				).subscribe(resp => {
					resp_data = resp.data;
					this.data = resp_data.data;
					// this.data = [];

					callback({
						recordsTotal: resp_data.recordsTotal,
						recordsFiltered: resp_data.recordsFiltered,
						data: []
					});
				});
			},
			columns: [{ data: 'business_name' }, { data: 'email' },{ data: 'plan' }, { data: 'amount' }, { data: 'created_at' }, { data: 'status' }, { data: 'action' }],
			columnDefs: [ {
				'targets': [0,2,3,5,6], // column index (start from 0)
				'orderable': false, // set orderable false for selected columns
			}]
		});
    }

    // getMerchant() {
    //     var data = {
    //         token: this.token,
    //     }
    //     let responseData = < any > {};
    //     this.busy = this.echexpaymentService.getMerchantList(data).subscribe(
    //         response => {
    //             responseData = response;
    //             this.data = responseData.data;
    //         },
    //         error => {
    //             responseData = error;
    //             this.toastr.error(responseData.error.message, 'Failed!');
    //         }
    //     );
    // }
    // delete merchant
    deleteMerchant(event, m_id) {
        event.stopPropagation();
        this.modal.confirm()
            .size('sm')
            .title('CasherPay')
            .body(`Are you sure to delete this merchant.`)
            .okBtn('Okay')
            .cancelBtn('Cancel')
            .okBtnClass('btn btn-success')
            .cancelBtnClass('btn btn-warning')
            .open()
            .then((resultPromise) => {
                resultPromise.result.then((result) => {
                        var data = {
                            token: this.token,
                            user_token: this.token,
                            id: m_id,
                            status: '11'
                        }
                        let responseData = < any > {};
                        this.busy = this.echexpaymentService.deleteMerchant(data).subscribe(
                            response => {
                                responseData = response;
                                this.toastr.success(responseData.message, 'Success!');
                                this.getAllTransactionAdvance();
                            },
                            error => {
                                responseData = error;
                                this.toastr.error(responseData.error.message, 'Failed!');
                            }
                        );
                    },
                    () => {
                        console.log('Cancel');
                    });
            });
    }
    // Merchant Lock/unlock
    merchantLockUnlock(event, m_id, status_id, label: string) {
        event.stopPropagation();
        this.modal.confirm()
            .size('sm')
            .title('CasherPay')
            .body(`Are you sure to ${label} this merchant.`)
            .okBtn('Okay')
            .cancelBtn('Cancel')
            .okBtnClass('btn btn-success')
            .cancelBtnClass('btn btn-warning')
            .open()
            .then((resultPromise) => {
                resultPromise.result.then((result) => {
                        var data = {
                            token: this.token,
                            user_token: this.token,
                            id: m_id,
                            status: status_id
                        }
                        let responseData = < any > {};
                        this.busy = this.echexpaymentService.merchantLockUnlock(data).subscribe(
                            response => {
                                responseData = response;
                                this.toastr.success(responseData.message, 'Success!');
                                this.getAllTransactionAdvance();
                            },
                            error => {
                                responseData = error;
                                this.toastr.error(responseData.error.message, 'Failed!');
                            }
                        );
                    },
                    () => {
                        console.log('Cancel');
                    });
            });
    }
    // Ghost login
    ghostLogin(event, m_id) {

        event.stopPropagation();
        var data = {
            user_token: this.token,
            token: m_id,
            id: m_id,
        }
        let responseData = < any > {};
        this.busy = this.echexpaymentService.ghostEnable(data).subscribe(
            response => {
                responseData = response;

                var token = responseData.data;
                var currentUser_token = this.currentUser;
                this.localStorageService.setData("super_admin_token", currentUser_token);

                //removing super admin token
                this.localStorageService.removeData('currentUserToken');
                var authData = {
                    data: responseData.data
                }
                this.localStorageService.setData("currentUserToken", authData)
                this.getAuth(token);
            },
            error => {
                responseData = error;
                this.toastr.error(responseData.error.message, 'Failed!');

            }
        );
    }

    // Get Auth Data
    getAuth(data) {
        var authData = {
            //token :data,
            data: data
        }
        let responseData = < any > {};
        this.busy = this.userService.getAuthUser(authData).subscribe(
            response => {
                responseData = response;
                let super_admin_details = this.localStorageService.getData("currentUser");
                this.localStorageService.setData("super_admin_detail", super_admin_details);
                //for hide and show btn
                this.localStorageService.setData("merchantAdmin", "true");

                this.localStorageService.removeData('currentUser');
                this.localStorageService.setData('currentUser', responseData.data);
                let userDetails = this.localStorageService.getData("currentUser");
                this.globalEventMangerService.showNavBar(true);
                this.globalEventMangerService.ghostLogin(true);
                if (userDetails.role_id == '3') {
                    this.router.navigate(['/dashboard']);
                }
            },
            error => {
                responseData = error;
                this.toastr.error(responseData.error.message, 'Failed!');
            }
        );
    }

    // ngAfterViewInit() {
    //     this.renderer.selectRootElement('#initialSearch_check').focus();
    // }
}


// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/echexmerchant/echexmerchant.component.ts